const URL_MARKETPLACE = '/';
const URL_HOME = 'https://www.surmount.ai/';

// Strategy
const URL_STRATEGY_DETAILS = '/strategy-details/:id';
const URL_STRATEGY_PAYMENT = '/strategy/:strategyId/payment';
const URL_DEPLOY_STRATEGY = '/deploy-strategy';

// Login
const URL_LOGIN = '/login';
const URL_FORGOT_PASSWORD = '/forgot-password';
const URL_RESET_PASSWORD = '/reset-password/:userId';

// Portfolio
const URL_PORTFOLIO = '/portfolio/:id/:userId';
const URL_PROFILE = '/profile';
const URL_HOST_PORTFOLIO = '/host-portfolio/:portfolioId?';
const URL_COPY_TRADING_PAYMENT = '/portfolio/:userPortfolioId/payment';
const URL_AI_BOTS = 'https://dashboard.surmount.ai/nn-allocation';
const URL_BOTS = '/bots/:botType';
const URL_PORTFOLIO_DETAILS = '/portfolio-details/:portfolioId';

// Registration
const URL_REGISTRATION = '/registration/:userId?';
const URL_EMAIL_VERIFICATION = '/verify-email';
const URL_EMAIL_VERIFICATION_REDIRECT = '/verify-email/:userId';

// Pages
const TERM_CONDITIONS_PDF = 'https://surmount-ai.s3.us-east-2.amazonaws.com/public-assets/Terms+%26+Conditions.pdf';
const USE_RISK_PDF = 'https://surmount-ai.s3.us-east-2.amazonaws.com/public-assets/Use+%26+Risk+.pdf';
const URL_NOT_FOUND = '/not-found';

// No Code Builder
const URL_NO_CODE_BUILDER = '/no-code-builder/:strategyId';
const URL_CREATE_BOT = '/create-bot';
const URL_HOST_BOT = '/host-bot/:strategyId';

export {
  URL_MARKETPLACE,
  URL_PORTFOLIO,
  URL_STRATEGY_DETAILS,
  URL_REGISTRATION,
  TERM_CONDITIONS_PDF,
  USE_RISK_PDF,
  URL_EMAIL_VERIFICATION,
  URL_LOGIN,
  URL_NOT_FOUND,
  URL_PROFILE,
  URL_FORGOT_PASSWORD,
  URL_RESET_PASSWORD,
  URL_STRATEGY_PAYMENT,
  URL_NO_CODE_BUILDER,
  URL_HOST_PORTFOLIO,
  URL_COPY_TRADING_PAYMENT,
  URL_CREATE_BOT,
  URL_AI_BOTS,
  URL_BOTS,
  URL_DEPLOY_STRATEGY,
  URL_PORTFOLIO_DETAILS,
  URL_HOME,
  URL_HOST_BOT,
  URL_EMAIL_VERIFICATION_REDIRECT,
};
